import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
};

const Navbar = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const go = (id) => {
    if (location.pathname !== "/") {
      navigate("/");
      setTimeout(() => scrollToId(id), 350);
    } else {
      scrollToId(id);
    }
  };

  return (
    <div className="fixed top-4 left-0 right-0 z-50 flex justify-center px-4">
      <nav
        data-testid="navbar"
        className="flex items-center gap-2 sm:gap-6 rounded-full border border-[#1c2740] bg-[#0a1020]/90 backdrop-blur-md pl-4 pr-2 py-2 shadow-[0_8px_30px_rgba(0,0,0,0.5)]"
      >
        <button
          onClick={() => { navigate("/"); window.scrollTo({ top: 0, behavior: "smooth" }); }}
          className="flex items-center cursor-pointer"
          data-testid="nav-logo"
        >
          <img
            src="https://customer-assets-lqy194kg.emergentagent.net/job_funding-webinar/artifacts/94m11zb2_image.png"
            alt="Great Western Funding"
            className="h-9 w-auto rounded-full"
          />
        </button>
        <div className="flex items-center gap-1 sm:gap-2">
          <button onClick={() => go("problem")} data-testid="nav-learn" className="px-2 sm:px-3 py-1.5 font-mono text-[10px] tracking-[0.25em] uppercase text-[#aeb9d4] hover:text-white transition-colors">Learn</button>
          <button onClick={() => go("host")} data-testid="nav-host" className="px-2 sm:px-3 py-1.5 font-mono text-[10px] tracking-[0.25em] uppercase text-[#aeb9d4] hover:text-white transition-colors">Host</button>
          <button onClick={() => go("faq")} data-testid="nav-faq" className="px-2 sm:px-3 py-1.5 font-mono text-[10px] tracking-[0.25em] uppercase text-[#aeb9d4] hover:text-white transition-colors">FAQ</button>
        </div>
        <button
          onClick={() => go("register")}
          data-testid="nav-register"
          className="cta-glow flex items-center gap-1.5 rounded-full bg-[#3f639f] hover:bg-[#4f76b8] text-white font-mono text-[10px] tracking-[0.25em] uppercase px-4 sm:px-5 py-2.5"
        >
          Register <ArrowUpRight size={13} />
        </button>
      </nav>
    </div>
  );
};

export default Navbar;
